/**
 * Generated runtime TestId mirror for frontend/src/pages/PartyDetail.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const PartyDetailTestIds = {
  btnToggleOrgTree: "btn-toggle-org-tree",
  colCreatedAt: "col-created-at",
  colLifecycleState: "col-lifecycle-state",
  colType: "col-type",
  partyDetailPage: "party-detail-page",
  sectionAttributes: "section-attributes",
  sectionIdentities: "section-identities",
  sectionPartyHierarchy: "section-party-hierarchy",
  sectionRelationships: "section-relationships",
  btnAddRelationship: (schemaEntryId: string) => `btn-add-relationship-${schemaEntryId}`,
  btnAddRelationshipPrefix: () => "btn-add-relationship-" as TestIdPrefix,
  btnCancelAddRelationship: (schemaEntry_schemaEntryId: string) => `btn-cancel-add-relationship-${schemaEntry_schemaEntryId}`,
  btnCancelAddRelationshipPrefix: () => "btn-cancel-add-relationship-" as TestIdPrefix,
  btnCancelRemoveRelationship: (relationship_id: string) => `btn-cancel-remove-relationship-${relationship_id}`,
  btnCancelRemoveRelationshipPrefix: () => "btn-cancel-remove-relationship-" as TestIdPrefix,
  btnConfirmAddRelationship: (schemaEntry_schemaEntryId: string) => `btn-confirm-add-relationship-${schemaEntry_schemaEntryId}`,
  btnConfirmAddRelationshipPrefix: () => "btn-confirm-add-relationship-" as TestIdPrefix,
  btnConfirmRemoveRelationship: (relationship_id: string) => `btn-confirm-remove-relationship-${relationship_id}`,
  btnConfirmRemoveRelationshipPrefix: () => "btn-confirm-remove-relationship-" as TestIdPrefix,
  btnRemoveRelationship: (relationshipId: string) => `btn-remove-relationship-${relationshipId}`,
  btnRemoveRelationshipPrefix: () => "btn-remove-relationship-" as TestIdPrefix,
  btnShowAll: (label_toLowerCase___replace___s__g: string) => `btn-show-all-${label_toLowerCase___replace___s__g}`,
  btnShowAllPrefix: () => "btn-show-all-" as TestIdPrefix,
  btnToggleSection: (label_toLowerCase___replace___s__g: string) => `btn-toggle-section-${label_toLowerCase___replace___s__g}`,
  btnToggleSectionPrefix: () => "btn-toggle-section-" as TestIdPrefix,
  comboboxAddRelationship: (schemaEntry_schemaEntryId: string) => `combobox-add-relationship-${schemaEntry_schemaEntryId}`,
  comboboxAddRelationshipPrefix: () => "combobox-add-relationship-" as TestIdPrefix,
  dialogAddRelationship: (schemaEntry_schemaEntryId: string) => `dialog-add-relationship-${schemaEntry_schemaEntryId}`,
  dialogAddRelationshipPrefix: () => "dialog-add-relationship-" as TestIdPrefix,
  dialogRemoveRelationship: (relationship_id: string) => `dialog-remove-relationship-${relationship_id}`,
  dialogRemoveRelationshipPrefix: () => "dialog-remove-relationship-" as TestIdPrefix,
  linkAncestor: (ancestor_id: string) => `link-ancestor-${ancestor_id}`,
  linkAncestorPrefix: () => "link-ancestor-" as TestIdPrefix,
  linkIdentity: (identity_id: string) => `link-identity-${identity_id}`,
  linkIdentityPrefix: () => "link-identity-" as TestIdPrefix,
  linkOrg: (immediateParent_id: string) => `link-org-${immediateParent_id}`,
  linkOrgPrefix: () => "link-org-" as TestIdPrefix,
  linkRel: (party_id: string) => `link-rel-${party_id}`,
  linkRelPrefix: () => "link-rel-" as TestIdPrefix
} as const;
